import { Helmet } from 'react-helmet-async';

export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://protectyourcrown.store",
    "name": "Protect Your Crown",
    "image": "https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/9wiwyrj8_CJhome%20page.jpg",
    "description": "Protect Your Crown is a Sacramento-based artisan crochet brand founded in 2023 by Christian Clark. We hand-crochet premium dreadlock hats, beanie hats, slouchy tams, infinity scarves, and shawls using soft acrylic and cotton-blend yarns. 15 unique designs from $30-$100. Custom orders available. Ships nationwide via USPS.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Sacramento",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "38.5816",
      "longitude": "-121.4944"
    },
    "url": "https://protectyourcrown.store",
    "telephone": "",
    "email": "info@protectmycrown.com",
    "priceRange": "$30-$100",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "founder": {
      "@type": "Person",
      "name": "Christian Clark",
      "jobTitle": "Founder & Artisan Crocheter",
      "description": "Self-taught crocheter based in Sacramento, California. Specializes in dreadlock-friendly hat designs using acrylic and cotton-blend yarns."
    },
    "foundingDate": "2023",
    "numberOfEmployees": "1",
    "knowsAbout": ["crochet", "dreadlock hats", "beanie hats", "handmade hats", "crocheted shawls", "artisan crafts"],
    "areaServed": [
      {
        "@type": "City",
        "name": "Sacramento"
      },
      {
        "@type": "State",
        "name": "California"
      },
      {
        "@type": "Country",
        "name": "United States"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Handcrafted Crocheted Items",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Beanie Hats",
          "description": "Hand-crocheted beanie hats in solid colors, gradients, and multicolor patterns. Made with soft acrylic yarn. 4-6 hours craft time per hat.",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Earth's Song", "description": "Multicolor earthy toned crocheted beanie hat - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Soul-shine", "description": "Golden yellow crocheted beanie hat - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Ocean Breeze", "description": "Sky blue to navy gradient crocheted beanie - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Forest Dreams", "description": "Multicolor striped crocheted beanie - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Sunset Glow", "description": "Orange, pink, and red crocheted beanie - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Minty Bong Water", "description": "Minty turquoise crocheted beanie hat - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Seasons of Joy", "description": "Blue and grey gradient crocheted beanie hat - $30" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Dreadlock Hats & Tams",
          "description": "Oversized slouchy hats designed for dreadlocks, braids, twists, and natural hair. Extra depth and stretch. 6-8 hours craft time.",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Rasta", "description": "Rasta-style dreadlock hat with green, gold, and red stripes on black - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Multi-color Vibin'", "description": "Colorful rainbow dreadlock hat - $30" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "XL Rasta Dreadlock Tam", "description": "Extra-large Rasta dreadlock tam with green, yellow, red, and black stripes - $60" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Premium Collection",
          "description": "Higher-tier designs with intricate stitch patterns and more construction hours.",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Raspberry Hombre", "description": "Pink ombre crocheted beanie - $45" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Supreme", "description": "Premium multicolor crocheted hat - $65" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Aurora Chevron Shawl", "description": "Signature 60x30 inch chevron shawl with 15+ colors, 40+ hours handcraft time - $100" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Accessories",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Blue Infinity Scarf", "description": "Blue crocheted continuous-loop infinity scarf - $50" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Summer Sun", "description": "Wide-brimmed crocheted sun hat in orange - $30" } }
          ]
        }
      ]
    },
    "sameAs": []
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const FAQSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Where can I buy handcrafted dreadlock hats in Sacramento?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Protect Your Crown is a Sacramento-based artisan crochet brand that sells handcrafted dreadlock hats starting at $30. Founded in 2023 by Christian Clark, we specialize in oversized slouchy hats designed specifically for dreadlocks, braids, twists, and natural hair. Popular styles include the Rasta dreadlock hat ($30) and the XL Rasta Dreadlock Tam ($60). All hats are crocheted by hand using soft acrylic yarn and ship nationwide from Sacramento via USPS within 3-5 business days."
        }
      },
      {
        "@type": "Question",
        "name": "What types of crocheted hats does Protect Your Crown sell?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Protect Your Crown offers 15 unique handcrafted items across five categories: Beanie Hats ($30), Dreadlock Hats & Tams ($30-$60), Premium Hats ($45-$65), Scarves & Accessories ($30-$50), and Signature Shawls ($100). All items are hand-crocheted in Sacramento, California by Christian Clark using premium acrylic and cotton-blend yarns. Custom orders are also available starting at $30."
        }
      },
      {
        "@type": "Question",
        "name": "How much do crocheted hats cost at Protect Your Crown?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prices range from $30 to $100. Standard beanies and dreadlock hats start at $30. Raspberry Hombre is $45. Blue Infinity Scarf is $50. XL Rasta Dreadlock Tam is $60. Supreme hat is $65. Aurora Chevron Shawl is $100 with free shipping. Custom orders start at $30. All prices reflect handcrafted production taking 4 to 40+ hours per piece."
        }
      },
      {
        "@type": "Question",
        "name": "Can I order a custom crocheted hat from Protect Your Crown?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, custom orders are available. Visit the Products page to fill out the custom order form or email info@protectmycrown.com. Choose your style, colors, and size. Custom beanies start at $30 with 5-10 business day turnaround. Christian Clark will respond within 1-2 business days with a quote."
        }
      },
      {
        "@type": "Question",
        "name": "Who is Christian Clark and who makes the hats at Protect Your Crown?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Christian Clark is the founder and sole artisan behind Protect Your Crown. A self-taught crocheter based in Sacramento, California, Christian launched the brand in 2023 and personally hand-crochets every item sold. Techniques include single crochet, half-double crochet, double crochet, and ripple stitch. The Aurora Chevron Shawl takes over 40 hours to complete."
        }
      },
      {
        "@type": "Question",
        "name": "What are dreadlock hats and how are they different from regular beanies?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Dreadlock hats are oversized crocheted hats designed to fit comfortably over dreadlocks, locs, braids, twists, and thick natural hair. They feature extra depth and room in the crown, stretchy crochet construction, a slouchy fit that won't pull or snag hair, and soft acrylic yarn that reduces friction. The Rasta ($30) and XL Rasta Dreadlock Tam ($60) are our most popular dreadlock hats."
        }
      },
      {
        "@type": "Question",
        "name": "What is the Aurora Chevron Shawl from Protect Your Crown?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Aurora Chevron Shawl is a 60x30 inch handcrafted crochet shawl with 15+ yarn colors in a chevron zigzag pattern. Priced at $100 with free shipping. Each shawl takes over 40 hours to create using a ripple stitch technique with premium soft acrylic yarn. Wearable as a wrap, poncho, triangle scarf, or drape. Machine washable on gentle cycle."
        }
      },
      {
        "@type": "Question",
        "name": "What materials are used in Protect Your Crown hats?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We use soft acrylic yarn (hypoallergenic, machine washable, colorfast) for most products and cotton-blend yarn for breathable summer designs. Yarns are sourced from U.S. suppliers. Medium-weight worsted (#4) for standard hats, bulky-weight (#5) for oversized items. Crochet hooks range from H/8 (5.0mm) to K/10.5 (6.5mm)."
        }
      },
      {
        "@type": "Question",
        "name": "How do I wash and care for crocheted hats?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Machine wash on gentle/delicate cycle with cold water or hand wash with mild detergent. Lay flat to air dry on a clean towel. Do not wring, twist, or tumble dry on high heat. Store flat or loosely rolled. Use a fabric shaver for any pilling. With proper care, our crocheted items last for years."
        }
      },
      {
        "@type": "Question",
        "name": "Does Protect Your Crown ship outside Sacramento?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we ship to all 50 U.S. states via USPS from Sacramento, CA. In-stock items ship within 3-5 business days. Custom orders ship within 7-10 business days. The Aurora Chevron Shawl includes free shipping. All orders include tracking numbers."
        }
      },
      {
        "@type": "Question",
        "name": "Is Protect Your Crown a Black-owned business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Protect Your Crown is a Black-owned small business based in Sacramento, California, founded in 2023 by Christian Clark. Christian personally hand-crochets every item sold. The brand specializes in hats designed for dreadlocks, braids, and natural hair."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const ProductCollectionSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Protect Your Crown Product Collection",
    "description": "15 handcrafted crocheted hats, scarves, and shawls from Sacramento by Christian Clark. Dreadlock hats, beanies, tams, infinity scarves, and the signature Aurora Chevron Shawl. Prices from $30-$100.",
    "numberOfItems": 15,
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "item": { "@type": "Product", "name": "Earth's Song", "description": "Multicolor earthy toned crocheted beanie hat - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 2, "item": { "@type": "Product", "name": "Rasta", "description": "Rasta-style dreadlock hat with green, gold, red stripes on black - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 3, "item": { "@type": "Product", "name": "Multi-color Vibin'", "description": "Colorful rainbow crocheted dreadlock hat - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 4, "item": { "@type": "Product", "name": "Soul-shine", "description": "Golden yellow crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 5, "item": { "@type": "Product", "name": "Ocean Breeze", "description": "Sky blue to navy gradient crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 6, "item": { "@type": "Product", "name": "Forest Dreams", "description": "Multicolor striped crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 7, "item": { "@type": "Product", "name": "Sunset Glow", "description": "Orange, pink, red crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 8, "item": { "@type": "Product", "name": "Summer Sun", "description": "Wide-brimmed crocheted sun hat - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 9, "item": { "@type": "Product", "name": "Minty Bong Water", "description": "Mint turquoise crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 10, "item": { "@type": "Product", "name": "Seasons of Joy", "description": "Blue and grey gradient crocheted beanie - $30", "offers": { "@type": "Offer", "price": "30", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 11, "item": { "@type": "Product", "name": "Raspberry Hombre", "description": "Pink ombre crocheted beanie - $45", "offers": { "@type": "Offer", "price": "45", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 12, "item": { "@type": "Product", "name": "Blue Infinity Scarf", "description": "Blue crocheted continuous-loop infinity scarf - $50", "offers": { "@type": "Offer", "price": "50", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 13, "item": { "@type": "Product", "name": "XL Rasta Dreadlock Tam", "description": "Extra-large Rasta dreadlock tam in green, yellow, red, black - $60", "offers": { "@type": "Offer", "price": "60", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 14, "item": { "@type": "Product", "name": "Supreme", "description": "Premium multicolor crocheted hat - $65", "offers": { "@type": "Offer", "price": "65", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } },
      { "@type": "ListItem", "position": 15, "item": { "@type": "Product", "name": "Aurora Chevron Shawl", "description": "Signature 60x30 inch chevron shawl with 15+ colors - $100 with free shipping", "offers": { "@type": "Offer", "price": "100", "priceCurrency": "USD", "availability": "https://schema.org/InStock" } } }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Protect Your Crown",
    "url": "https://protectyourcrown.store",
    "logo": "https://customer-assets.emergentagent.com/job_protect-your-crown/artifacts/9wiwyrj8_CJhome%20page.jpg",
    "description": "Protect Your Crown is a Black-owned artisan crochet brand in Sacramento, CA. Founded in 2023 by Christian Clark. Hand-crocheted dreadlock hats, beanie hats, slouchy tams, infinity scarves, and shawls. 15 unique designs from $30-$100. Uses premium acrylic and cotton-blend yarns. Custom orders available. Ships nationwide via USPS.",
    "foundingDate": "2023",
    "founder": {
      "@type": "Person",
      "name": "Christian Clark",
      "jobTitle": "Founder & Artisan Crocheter"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Sacramento",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@protectmycrown.com",
      "contactType": "customer service",
      "availableLanguage": "English"
    },
    "knowsAbout": ["crochet", "dreadlock hats", "beanie hats", "handmade hats", "crocheted shawls", "artisan crafts", "natural hair accessories"]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const HowToSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How Protect Your Crown Crocheted Hats Are Made",
    "description": "The step-by-step process Christian Clark uses to hand-crochet each hat, scarf, and shawl at Protect Your Crown in Sacramento, California.",
    "totalTime": "PT6H",
    "estimatedCost": {
      "@type": "MonetaryAmount",
      "currency": "USD",
      "value": "30"
    },
    "supply": [
      { "@type": "HowToSupply", "name": "Soft acrylic yarn or cotton-blend yarn" },
      { "@type": "HowToSupply", "name": "Crochet hook (size H/8 to K/10.5)" }
    ],
    "tool": [
      { "@type": "HowToTool", "name": "Aluminum or steel crochet hook" },
      { "@type": "HowToTool", "name": "Yarn needle for weaving in ends" },
      { "@type": "HowToTool", "name": "Scissors" },
      { "@type": "HowToTool", "name": "Steamer for blocking" }
    ],
    "step": [
      {
        "@type": "HowToStep",
        "name": "Yarn Selection",
        "text": "Christian hand-selects premium acrylic or cotton-blend yarns based on the design. Yarn is chosen for softness, durability, colorfastness, and weight. Medium-weight worsted (#4) for standard hats; bulky-weight (#5) for oversized tams."
      },
      {
        "@type": "HowToStep",
        "name": "Pattern Design",
        "text": "An original pattern is created or selected for the piece. Stitch techniques include single crochet, half-double crochet, double crochet, and ripple stitch. Color placement is planned for gradients, stripes, or custom patterns."
      },
      {
        "@type": "HowToStep",
        "name": "Hand Crochet",
        "text": "Using steel or aluminum crochet hooks (sizes H/8 through K/10.5), the piece is crocheted entirely by hand. A beanie takes 4-6 hours, a dreadlock tam takes 6-8 hours, and the Aurora Chevron Shawl takes 40+ hours."
      },
      {
        "@type": "HowToStep",
        "name": "Finishing and Shipping",
        "text": "Loose ends are woven in with a yarn needle. The piece is steam-blocked to set its shape. After inspection, orders ship within 3-5 business days via USPS from Sacramento, CA."
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const ProductSchema = ({ product }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "image": product.image,
    "description": `Handcrafted ${product.name} crocheted by Christian Clark in Sacramento, CA. Premium quality artisan crochet work using soft acrylic yarn. One-of-a-kind design. Ships nationwide.`,
    "brand": {
      "@type": "Brand",
      "name": "Protect Your Crown"
    },
    "manufacturer": {
      "@type": "Person",
      "name": "Christian Clark"
    },
    "offers": {
      "@type": "Offer",
      "url": "https://protectyourcrown.store/products",
      "priceCurrency": "USD",
      "price": product.price,
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "Protect Your Crown"
      },
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "US"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 3,
            "maxValue": 5,
            "unitCode": "DAY"
          }
        }
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
